import React, {
  InputHTMLAttributes,
  forwardRef,
  useState,
  useEffect,
  useCallback,
} from "react";

interface FileUploaderProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, "onChange"> {
  file?: File | null;
  existingUrl?: string;
  onChange?: (file: File | null) => void;
}

const FileUploaderV2 = forwardRef<HTMLInputElement, FileUploaderProps>(
  function FileUploader(props, ref) {
    const { file, existingUrl, onChange, ...inputProps } = props;

    const [editMode, setEditMode] = useState(false);
    const [fileUrl, setFileUrl] = useState<string | null>(null);

    useEffect(() => {
      if (file instanceof File) {
        const url = URL.createObjectURL(file);
        setFileUrl(url);

        return () => {
          URL.revokeObjectURL(url);
        };
      } else {
        setFileUrl(null);
      }
    }, [file]);

    const displayUrl = fileUrl || existingUrl || null;

    const handleFileChange = useCallback(
      (e: React.ChangeEvent<HTMLInputElement>) => {
        const selectedFile = e.target.files?.[0];

        if (selectedFile && onChange) {
          onChange(selectedFile);
          setEditMode(false);
        }
      },
      [onChange],
    );

    return (
      <div className="border rounded-sm px-2 py-1 bg-white">
        {displayUrl && !editMode ? (
          <div className="d-flex align-items-center gap-2 justify-content-between">
            <div className="d-flex align-items-center gap-2">
              <img
                src={displayUrl}
                alt="Preview"
                className="w-5 h-5 rounded-sm"
              />

              <a
                href={displayUrl}
                target="_blank"
                rel="noreferrer"
                className="font-semibold text-sm text-dark"
              >
                {file instanceof File ? "Nouveau fichier" : "Téléchargé"}
              </a>
            </div>

            <button
              type="button"
              className="btn btn-sm text-danger"
              onClick={() => setEditMode(true)}
            >
              Modifier
            </button>
          </div>
        ) : (
          <div className="d-flex align-items-center justify-content-between">
            <input
              type="file"
              ref={ref}
              {...inputProps}
              onChange={handleFileChange}
            />

            {editMode && (
              <button
                type="button"
                className="btn btn-sm text-secondary"
                onClick={() => setEditMode(false)}
              >
                Annuler
              </button>
            )}
          </div>
        )}
      </div>
    );
  },
);

export default FileUploaderV2;
